import React from 'react';
import { connect } from 'react-redux';
import './index.less';

class Chart extends React.Component {
    constructor(props) {
        super(props);
        this.chartDiv = React.createRef();
    }

    componentDidMount() {
        //需配合webpack把echarts分包出去
        import('echarts').then(echarts => {
            this.myChart = echarts.init(this.chartDiv, 'light');
            this.props.getChildEchart(this.myChart);
            const { type, xAxisData, seriesData, xAxisName, yAxisName } = this.props;
            this.renderChartByType(type, xAxisData, seriesData, xAxisName, yAxisName);
        });
    }

    componentWillReceiveProps(nextProps) {
        try {
            const { type, xAxisData, seriesData, xAxisName, yAxisName } = nextProps;
            this.renderChartByType(type, xAxisData, seriesData, xAxisName, yAxisName);
        } catch (e) {
            console.log(e);
        }
    }





    renderChartByType(type, xAxisData, seriesData, xAxisName, yAxisName) {
        if (!this.myChart) return;
        this.myChart.clear();
        switch (type) {
            case 'line':
                this.renderLine(xAxisData, seriesData, xAxisName, yAxisName);
                break;
            case 'bar':
                this.renderBar(xAxisData, seriesData, xAxisName, yAxisName);
                break;
            case 'pi':
                this.renderPi(xAxisData, seriesData, xAxisName, yAxisName);
                break;
            default:
                this.renderLine(xAxisData, seriesData, xAxisName, yAxisName);
                break;
        }
    }

    renderLine(xAxisData, seriesData, xAxisName, yAxisName) {
        let option = {
            legend: {

            },
            tooltip: {},
            grid:{
                top:80,
                bottom:30
            },
            animation: false,
            xAxis: {
                name: xAxisName,
                type: 'category',
                data: xAxisData
            },
            yAxis: {
                name: yAxisName,
                type: 'value'
            },
            series: seriesData.map(i => {
                return {
                    name: i.name,
                    type: 'line',
                    data: i.data,
                    'label': {
                        'normal': {
                            'show': false,
                            'position': 'top',
                            'textStyle': {
                                'fontSize': 12
                            }
                        },
                        'emphasis': {
                            'show': true,
                            'textStyle': {
                                'fontSize': 12
                            }
                        }
                    },
                };
            })
        };

        this.myChart.setOption(option);
    }

    renderBar(xAxisData, seriesData, xAxisName, yAxisName) {
        let option = {
            legend: {

            },
            grid:{
                top:80,
                bottom:30
            },
            tooltip: {},
            animation: false,

            xAxis: {
                name: xAxisName,
                type: 'category',
                data: xAxisData
            },
            yAxis: {
                name: yAxisName,
                type: 'value'
            },
            series: seriesData.map(i => {
                return {
                    name: i.name,
                    type: 'bar',
                    data: i.data,
                    'label': {
                        'normal': {
                            'show': false,
                            'position': 'top',
                            'textStyle': {
                                'fontSize': 12
                            }
                        },
                        'emphasis': {
                            'show': true,
                            'textStyle': {
                                'fontSize': 12
                            }
                        }
                    },
                };
            })
        };
        this.myChart.setOption(option);
    }

    render() {
        return (
            <div ref={el => this.chartDiv = el} id="chartCanvas"></div>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr
});

export default connect(
    mapStateToProps
)(Chart);